// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";
import uniqueId from "@insite/mobius/utilities/uniqueId";

export const TrackGaShareProduct: typeof SendDataToApi = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.shareProductEvent) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const billToState = getBillToState(state, state.context.session?.billToId);
        const customerNumber = billToState?.value?.customerNumber;

        const googleAnalyticsData = {
            event: "pdp_email_share",
            item: props.parameter.product.productTitle,
            user: customerNumber || uniqueId(),
            recipient_email: props.parameter.friendsEmailAddress,
            affiliation: customerNumber || "",
            item_id: props.parameter.product.productNumber,
            impersonation: trackAsImpersonation(state),
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, SendDataToApi, TrackGaShareProduct);
